export default __webpack_public_path__ + "static/media/publications.84f4fc18.png";